import { DraftSatoSetResponse, OnboardingStatus, TrayOnboardingStatus } from 'api/Responses/SatoResponses';
import { UpdateTrayVideo } from 'api/Responses/TrayResponses';
import axiosInstance from 'services/APIService';

const ENDPOINT_PATH_V2 = `/v2/sato`;

/**
 * Update the status of a Set
 * @returns Updated Set object
 */
export const updateSetStatus = async (
  zzCode: string,
  status: OnboardingStatus,
  comment?: string,
): Promise<DraftSatoSetResponse> => {
  const response = await axiosInstance.patch<DraftSatoSetResponse>(`${ENDPOINT_PATH_V2}/${zzCode}/`, {
    status,
    comment,
  });
  return response.data;
};

/**
 * Update the status of a Tray, in a given Set
 * @returns Update Set object
 */
export const updateTrayStatus = async (
  zzCode: string,
  trayId: string,
  status: TrayOnboardingStatus,
  comment?: string,
): Promise<DraftSatoSetResponse> => {
  const response = await axiosInstance.patch<DraftSatoSetResponse>(`${ENDPOINT_PATH_V2}/${zzCode}/tray/${trayId}/`, {
    status,
    comment,
  });
  return response.data;
};

export const updateSetData = async (zzCode: string): Promise<DraftSatoSetResponse> => {
  const response = await axiosInstance.put<DraftSatoSetResponse>(`${ENDPOINT_PATH_V2}/${zzCode}/sync/`);
  return response.data;
};

/**
 * Update a Tray's video with any number of parameters in the UpdateTrayVideo
 * interface. Any parameters present is this object will update the same
 * params in the Video object in Firestore.
 * @param zzCode
 * @param trayId
 * @param video Partial video object to merge with Firestore
 * @returns Updated Set object
 */
export const updateVideo = async (
  zzCode: string,
  trayId: string,
  video: UpdateTrayVideo,
): Promise<DraftSatoSetResponse> => {
  const response = await axiosInstance.put<DraftSatoSetResponse>(
    `${ENDPOINT_PATH_V2}/${zzCode}/tray/${trayId}/videos/`,
    video,
  );
  return response.data;
};

/**
 * @returns All draft Sets in Firestore
 */
export const getAllDrafts = async (): Promise<DraftSatoSetResponse[]> => {
  const response = await axiosInstance.get<DraftSatoSetResponse[]>(`${ENDPOINT_PATH_V2}/`);
  return response.data;
};
